// extracted by mini-css-extract-plugin
export default {"wrapper":"Mp-z","response":"Np-z","error":"Op-z","disabled":"Pp-z","buttons":"Qp-z","feedbackQuestionSection":"Rp-z","yesNoWrapper":"Sp-z"};